import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaLocationArrow, FaMapMarkerAlt, FaSpinner } from 'react-icons/fa';
import '../styles/LocationInput.css';

const LocationInput = ({ onSubmitLocation, isLoading }) => {
  const [city, setCity] = useState('');
  const [country, setCountry] = useState('');
  const [gettingLocation, setGettingLocation] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    
    if (city.trim() && country.trim()) {
      onSubmitLocation({ city, country });
    } else {
      setError('Please enter both city and country');
    }
  };

  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      setGettingLocation(true);
      setError('');
      
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          onSubmitLocation({ latitude, longitude });
          setGettingLocation(false);
        },
        (error) => {
          console.error('Error getting location:', error);
          setGettingLocation(false);
          setError('Unable to get your location. Please enter manually or try again.');
        },
        { 
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    } else {
      setError('Geolocation is not supported by your browser. Please enter your location manually.');
    }
  };

  return (
    <motion.div 
      className="location-input-container"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <div className="glass-card">
        <h2>Discover music based on location</h2>
        <p>Get music recommendations based on your current location or enter a city</p>
        
        <motion.button 
          className="location-btn"
          onClick={handleGetCurrentLocation}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          disabled={isLoading || gettingLocation}
        >
          {gettingLocation ? (
            <><FaSpinner className="spinner" /> Getting location...</>
          ) : (
            <><FaLocationArrow /> Use my current location</>
          )}
        </motion.button>
        
        <div className="divider">
          <span>OR</span>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="input-row">
            <div className="input-group">
              <FaMapMarkerAlt className="input-icon" />
              <input
                type="text"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                placeholder="City"
                disabled={isLoading}
              />
            </div>
            <div className="input-group">
              <input
                type="text"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                placeholder="Country"
                disabled={isLoading}
              />
            </div>
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <motion.button 
            type="submit"
            className="submit-btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            disabled={isLoading || !city || !country}
          >
            {isLoading ? <FaSpinner className="spinner" /> : 'Find Music'}
          </motion.button>
        </form>
      </div>
    </motion.div>
  );
};

export default LocationInput;
